import ProgramIcon from '../../assets/customIcons/programIcon';
import ApplicantProcessIcon from '../../assets/customIcons/applicantProcess';

import { ORGANIZATION, PROGRAMS, TEMPLATES_APP_PROCESS } from '../../constants/routes';
import type { ReactElement } from 'react';
import Organization from '../../assets/customIcons/Organization';
import { AUDITOR_ACCOUNT_TYPE } from '../../constants/common';
/**
 * Defines the primary navigation links for the application's side navigation.
 * Each link includes an icon, title, route path, and availability flag.
 *
 * @interface PrimaryLink
 * @property {ReactElement} icon - The icon to display for the link.
 * @property {string} title - The display name of the navigation link.
 * @property {string} linkTo - The route path the link navigates to.
 * @property {boolean} available - Whether the link should be shown in the navigation.
 */
interface PrimaryLink {
	icon: ReactElement;
	title: string;
	linkTo: string;
	available: boolean;
}

/**
 * Defines the primary navigation links for the application's side navigation.
 * Each link includes an icon, title, route path, and availability flag.
 *
 * @constant
 * @type {PrimaryLink[]}
 */
const allPrimaryLinks: PrimaryLink[] = [
	{
		icon: <ProgramIcon width={'28px'} isMulti />,
		title: 'Programs',
		linkTo: PROGRAMS,
		available: true
	},
	{
		icon: (
			<ApplicantProcessIcon
				isTemplate={true}
				isActive={false}
				width="28px"
				status={undefined}
				isBlueprint={false}
				isCurrentStage={false}
				isArchived={false}
				isWarning={false}
				customColor={undefined}
			/>
		),
		title: 'Templates',
		linkTo: TEMPLATES_APP_PROCESS,
		available: true
	},
	{
		icon: <Organization />,
		title: 'Preferences',
		linkTo: ORGANIZATION,
		available: true
	}
];

/**
 * Returns filtered primary navigation links based on user account type.
 * Excludes Organization/Preferences link for auditor users.
 *
 * @param {number} userAccountTypeID - The user's account type ID
 * @returns {PrimaryLink[]} Filtered array of navigation links
 */
export const getPrimaryLinks = (userAccountTypeID: number): PrimaryLink[] => {
	if (userAccountTypeID === AUDITOR_ACCOUNT_TYPE) {
		return allPrimaryLinks.filter((link) => link.linkTo !== ORGANIZATION);
	}
	return allPrimaryLinks;
};

/**
 * @deprecated Use getPrimaryLinks(userAccountTypeID) instead for role-based filtering
 */
export const PrimaryLinks: PrimaryLink[] = allPrimaryLinks;
